import React, { useState, useEffect } from 'react';
import { angularService, retryWithDelay } from '.././../../utils';
import { useUserInfoQuery } from './api';

type Navigation = {
    name: string;
    active: boolean;
    route: string;
    navigation: 'top' | 'sidebar';
};
type Data = {
    currentUser: string;
    currentUserEmail: string;
    navigation: Navigation[] | [];
};

export function useMenuData() {
    // helper functions
    function setUserData(payload: object) {
        setData((prev) => ({ ...prev, ...payload }));
    }

    const [data, setData] = useState({ currentUser: '', currentUserEmail: '', navigation: [] } as Data);
    const [hash, setHash] = useState(window.location.hash);

    useUserInfoQuery((data) => {
        if (data && data.email) {
            setUserData({ currentUserEmail: data.email });
        }
    });

    useEffect(() => {
        window.onhashchange = () => {
            // This is not a timing attach (just a check if saved location hash doesn't equal to the current one)
            // eslint-disable-next-line
            if (hash !== window.location.hash) {
                setHash(window.location.hash);
            }
        };
    });

    useEffect(() => {
        retryWithDelay(() => {
            const zStatus = angularService('zStatus');
            setUserData({ currentUser: zStatus.currentUser });
        });
    }, [hash]);

    useEffect(() => {
        retryWithDelay(() => {
            const navigationService = angularService('zNavigationService');
            // @ts-ignore
            navigationService.get(window.config, true).then((navigation: Navigation[]) => {
                const onlyTopNavigation = navigation
                    .filter(navigationService.convert)
                    // @ts-ignore
                    .filter((nav) => nav.show && nav.navigation === 'top');

                setUserData({ navigation: onlyTopNavigation });
            });
        });
    }, [hash]);

    return data;
}
